export default originalString => {
    if (!originalString) {
        return "-";
    }

    return originalString.charAt(0).toUpperCase() + originalString.substring(1).toLowerCase();
};
